module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_fails.js
// module id = 2
// module chunks = 0